import { Check, X, Clock, Coins } from "lucide-react";
import { useState } from "react";
import { motion } from "framer-motion";

// Reusable inline editor component
const InlineEditor = ({
  value,
  onSave,
}: {
  value: number;
  onSave: (newVal: number) => void;
}) => {
  const [editing, setEditing] = useState(false);
  const [tempVal, setTempVal] = useState(value);

  return (
    <div className="flex items-center gap-2">
      {editing ? (
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="flex items-center gap-2"
        >
          <input
            type="number"
            value={tempVal}
            min={0}
            onChange={(e) => setTempVal(Number(e.target.value))}
            className="w-20 px-2 py-1 rounded-md text-sm bg-gray-800 text-white border border-gray-600 focus:ring-2 focus:ring-cyan-400"
          />
          <button
            onClick={() => {
              onSave(tempVal);
              setEditing(false);
            }}
            className="p-1 bg-green-600 hover:bg-green-700 rounded-full text-white"
          >
            <Check size={16} />
          </button>
          <button
            onClick={() => setEditing(false)}
            className="p-1 bg-red-600 hover:bg-red-700 rounded-full text-white"
          >
            <X size={16} />
          </button>
        </motion.div>
      ) : (
        <span
          className="cursor-pointer hover:text-cyan-400 flex items-center gap-1"
          onClick={() => {
            setTempVal(value);
            setEditing(true);
          }}
        >
          {value}
        </span>
      )}
    </div>
  );
};

export default InlineEditor;
